<div class="active-filters-panel" [class.margin-left-0]="isHierarchFilterHidden"
    *ngIf="(isActiveFiltersEnabled && isHierarchFilterActive && !isHierarchFilterHidden) || (isActiveFiltersEnabled && isAddfilterBtnEnabled)">
    <span class="filter-text-format">Active filters: </span>
    <div class="active-filters hierarchy-filter" [hidden]="isHierarchFilterHidden" *ngIf="isHierarchFilterActive" (click)="openGlobalFilterSideBar($event, 'hierarchy')">
        Hierarchy
    </div>
    <div class="active-filters" *ngIf="activeUniversalFilter.question_filter && isAddfilterBtnEnabled"
        (click)="openGlobalFilterSideBar($event, 'question_filter')">
        Questions
        <img class="filter-close-icon" (click)="clearActiveFilters($event, 'question_filter')"
            src="assets/images/close.svg" />
    </div>
    <div class="active-filters" *ngIf="activeUniversalFilter.text_filter  && isAddfilterBtnEnabled"
        (click)="openGlobalFilterSideBar($event, 'text_filter')">
        Text
        <img class="filter-close-icon" (click)="clearActiveFilters($event, 'text_filter')"
            src="assets/images/close.svg" />
    </div>
    <div class="active-filters" *ngIf="activeUniversalFilter.action_filter  && isAddfilterBtnEnabled"
        (click)="openGlobalFilterSideBar($event, 'action_filter')">
        Action
        <img class="filter-close-icon" (click)="clearActiveFilters($event, 'action_filter')"
            src="assets/images/close.svg" />
    </div>
    <div class="active-filters" *ngIf="activeUniversalFilter.transaction_filter  && isAddfilterBtnEnabled"
        (click)="openGlobalFilterSideBar($event, 'transaction_filter')">
        Metadata
        <img class="filter-close-icon" *ngIf="!isCohortAccessAvailable || (isCohortAccessAvailable && isOtherTagFilterAvailable)" (click)="clearActiveFilters($event, 'transaction_filter')"
            src="assets/images/close.svg" />
    </div>
</div>